var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6471 2.85075C13.6354 1.80114 11.9869 1.80114 10.9401 2.85075L3.47404 10.3168C1.76897 12.055 1.76897 14.8207 3.47404 16.5238C5.17834 18.2308 7.94396 18.2308 9.64709 16.5238L15.5846 10.5863C15.9518 10.223 16.5455 10.223 16.8776 10.5863C17.276 10.9535 17.276 11.5472 16.8776 11.8793L10.9401 17.8168C8.53771 20.2894 4.58459 20.2894 2.14826 17.8168C-0.289004 15.4144 -0.289004 11.4613 2.14826 9.0238L9.64709 1.52497C11.3932 -0.221865 14.2252 -0.221865 15.9401 1.52497C17.7213 3.27185 17.7213 6.10583 15.9401 7.81677L8.79553 15.0277C7.56115 16.2621 5.5299 16.1488 4.44006 14.7894C3.50959 13.6254 3.60256 11.9457 4.6549 10.891L10.5846 4.9613C10.9518 4.59802 11.5455 4.59802 11.8776 4.9613C12.276 5.32849 12.276 5.92224 11.8776 6.25427L5.98303 12.2152C5.60412 12.5941 5.56896 13.1996 5.9049 13.6175C6.29553 14.1058 7.026 14.1488 7.4674 13.7035L14.6471 6.5238C15.6627 5.51208 15.6627 3.86521 14.6471 2.85075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipIcon);
export default __webpack_public_path__ + "static/media/paper-clip-icon.07302a4f0a8ad3e94807b1fe2f5a05b4.svg";
export { ForwardRef as ReactComponent };